$(document).ready(function () {
  "use strict";

  $(window).scroll(function () {
    var headerHight = $(".main-header").height();
    const mainNavContainer = $(".main-nav-container");
    if ($(window).scrollTop() > headerHight) {
      mainNavContainer.addClass("sticky-navbar");
    } else {
      mainNavContainer.removeClass("sticky-navbar");
    }
  });

  const hash = window.location.pathname;
  const currentPage = hash.split("/").pop();

  $("#main-menu a").each(function (index) {
    const linkText = $(this).attr("data-id");
    if (!currentPage && index === 0) {
      $(this).addClass("active-link");

      return;
    }

    if (linkText == currentPage) {
      $(this).addClass("active-link");
    } else {
      $(this).removeClass("active-link");
    }
  });
  var menuItems = $("#main-menu").html();
  var mobileMenu = $(".mobile-menu-inner");
  mobileMenu.html(menuItems);

  var menuItems2 = $("#main-menu-2").html();
  mobileMenu.append(menuItems2);

  $("#mobile-menu-toggle").click(function () {
    $(".mobile-menu-container").addClass("active");
  });

  $(".close-mobile-menu").click(function () {
    $(".mobile-menu-container").removeClass("active");
  });

  $(".mobile-menu-inner").on("click", ".inner-menu-toggle", function () {
    $(this).parent().children(".inner-menu-list").slideToggle();
  });

  $(".products-home-slider").owlCarousel({
    loop: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 5000,
    item: 3,
    margin: 40,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      1279: {
        items: 3,
      },
    },
  });

  $(".product-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 6000,
    asNavFor: ".vertical-slider",
    prevArrow: $(".prev-arrow"),
    nextArrow: $(".next-arrow"),
  });
  $(".vertical-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".product-slider",
    dots: false,
    centerMode: false,
    focusOnSelect: false,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    vertical: true,
    verticalSwiping: true,
  });

  var proQty = $(".pro-qty");
  $(".qty-btn").on("click", function (e) {
    e.preventDefault();
    var $button = $(this);
    var oldValue = $button.parent().find("input").val();
    if ($button.hasClass("inc")) {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 1) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 1;
      }
    }
    $button.parent().find("input").val(newVal);
  });

  $("#faq-group-1 .item-btn").click(function () {
    var value = $(this).val();
    console.log(value);

    $("#faq-group-1 .item-btn").not(this).removeClass("active");

    $(this).toggleClass("active");

    $("#faq-group-1 .item-content").each(function () {
      if (value == $(this).attr("id")) {
        $("#faq-group-1 .item-content.active").not(this).slideToggle("medium");
        $("#faq-group-1 .item-content").not(this).removeClass("active");
        $(this).slideToggle("medium");
        $(this).toggleClass("active");
      }
    });
  });
  // Activate lightcase

  AOS.init();
});
$("a[data-rel^=lightcase]").lightcase();
